var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isRedirectPage)?_c('div',[_c('RedirectPage')],1):_c('div',[_c('Header'),_c('div',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }